import get from 'lodash/get';

export default (mrns = []) =>
  mrns.map(mrn => ({
    name: get(mrn, 'organization.name'),
    value: mrn.localUid,
  }));



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/generateMrnDescriptors.js